import RoomManagementTemplate from "../../../templates/admin/roomManagement";

const RoomManagementScreen = () => {
  return <RoomManagementTemplate />;
};

export default RoomManagementScreen;
